import { useCallback } from 'react'

import { useQuery, useQueryClient } from '@tanstack/react-query'

import { useAuth } from '@/features/auth/auth-context'
import { countOperatorConversations } from '@/features/projects/projects-api'
import { useProjectConversationsRealtime } from '@/features/projects/use-project-conversations-realtime'

const queueCountQueryKey = ['operator-conversations', 'count'] as const

export function useOperatorQueueCount(): number {
  const { isAuthenticated } = useAuth()
  const queryClient = useQueryClient()

  const countQuery = useQuery({
    queryKey: queueCountQueryKey,
    queryFn: countOperatorConversations,
    enabled: isAuthenticated,
    refetchInterval: 30_000,
    retry: false,
  })

  const onEvent = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: queueCountQueryKey })
  }, [queryClient])

  useProjectConversationsRealtime(onEvent, isAuthenticated)

  return countQuery.data ?? 0
}
